import React from 'react'

const Spinner = () => {
  return (
    <div id='loading'></div>
  )
}

export default Spinner